import { render, staticRenderFns } from "./ForumsList.vue?vue&type=template&id=693827ef&scoped=true&"
import script from "./ForumsList.vue?vue&type=script&lang=js&"
export * from "./ForumsList.vue?vue&type=script&lang=js&"
import style0 from "./ForumsList.vue?vue&type=style&index=0&id=693827ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693827ef",
  null
  
)

export default component.exports